var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointTransferRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.558,
    height: 24.53,
    viewBox: "0 0 20.558 24.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9890",
    "data-name": "Group 9890",
    transform: "translate(-934 -347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M-4148,1290h-4a3,3,0,0,1-3-3v-12a3,3,0,0,1,3-3h9a3,3,0,0,1,3,3v8.071a7.1,7.1,0,0,0-1-.071c-.213,0-.428.01-.638.029v-1.4h-8.521v-1.42l-2.84,2.13,2.84,2.13v-1.42h8.318A7,7,0,0,0-4148,1290Zm3.521-12.631v1.42l2.84-2.13-2.84-2.13v1.42H-4153v1.42Z",
    transform: "translate(5089 -925)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9878",
    "data-name": "Group 9878",
    transform: "translate(-4395.482 1870.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_11",
    "data-name": "Exclusion 11",
    d: "M6.533,13.045a6.526,6.526,0,1,1,2.541-.513,6.53,6.53,0,0,1-2.541.513ZM7.657,5.456h0v3h.714V4.644H7.218l-.683,2.6-.691-2.6H4.694V8.451h.714v-3l.753,3H6.9Z",
    transform: "translate(5336.975 -1512.027)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointTransferRecord);
export default __webpack_public_path__ + "static/media/PointTransferRecord.d2fa63d1.svg";
export { ForwardRef as ReactComponent };